import React from 'react';

import { analyticsService } from '@/app/analytics';

import { useShopInfo2 } from './hooks';

/**
 * 앰플리튜드 유저 프로퍼티 설정 이펙트
 */
export const useUserPropertiesEffect = () => {
  const { shopInfo } = useShopInfo2();

  React.useEffect(() => {
    analyticsService.setUserProperties({
      is_AI_description_on:
        shopInfo.itemInputFieldSetting?.find(v => v.code === 'SHOP_ITEM-INPUT_AI-DESCRIPTION')?.enable ?? false,
    });
  }, [shopInfo.itemInputFieldSetting]);
};
